<mat-sidenav-container
  class="sidenav-container"
  [class.sidenav-container--bare]="bareShell()"
  [class.sidenav-container--document-scroll]="documentScroll()"
>
  <mat-sidenav #drawer class="sidenav" fixedInViewport [style.height]="'auto'">
    <!-- Organization Selector -->
    @if ((userOrganizations$ | async)?.length === 1) {
      <mat-toolbar>
        {{ (organization$ | async)?.name }}
      </mat-toolbar>
    }
    @if ((userOrganizations$ | async)?.length && (userOrganizations$ | async)!.length >= 2) {
      <mat-toolbar>
        <mat-form-field class="org-select">
          <mat-select
            [value]="selectedOrg$ | async"
            [compareWith]="compareOrgs"
            (selectionChange)="changeOrg($event.value)"
          >
            @for (org of userOrganizations$ | async; track org.id) {
              <mat-option [value]="org">
                {{ org.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-toolbar>
    }

    <!-- Navigation Menu - Optimized -->
    <mat-nav-list>
      <!-- ✅ Use visibleRoutes$ instead of calling methods in template -->
      @for (route of visibleRoutes$ | async; track route.path) {
        @if (route.visible) {
          <a
            mat-list-item
            class="module-link"
            [routerLink]="route.link"
            [attr.aria-label]="route.accessibleName"
            (click)="drawer.toggle()"
          >
            <span class="module-link-content">
              <span class="module-link-name">{{ route.name }}</span>
              @if (route.destination) {
                <mat-icon class="cross-app-icon" aria-hidden="true">open_in_new</mat-icon>
              }
            </span>
          </a>
        }
      }

      <mat-divider></mat-divider>

      <!-- Profile, Language and Logout -->
      <ng-container *transloco="let t; prefix: 'nav'">
        @if (isProfileAvailable$ | async) {
          <a mat-list-item [routerLink]="'profile'" (click)="drawer.toggle()">{{ t('profile') }}</a>
        }
        <app-language-switcher class="lang-switcher-item" display="menuItem" />
        <a mat-list-item (click)="signOut()">{{ t('signOut') }}</a>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <!-- A mobile detail route carries its own page bar and scrolls as the
         document, so the shell renders no toolbar for it (ShellChromeService). -->
    @if (!bareShell()) {
      <div class="toolbar-container">
        <mat-toolbar color="primary" class="top-toolbar">
          <ng-container *transloco="let t; prefix: 'nav'">
            <button
              class="menu-toggle-button"
              type="button"
              [attr.aria-label]="t('toggleSidenav')"
              mat-icon-button
              (click)="drawer.toggle()"
            >
              <mat-icon aria-hidden="true">menu</mat-icon>
            </button>
          </ng-container>
          <span class="title">{{ title$ | async }}</span>
          <span class="flexExpand"></span>
          @if (showBackNavigation) {
            <button mat-button (click)="navigateBack()" type="button">
              <mat-icon appClickStopPropagation (click)="navigateBack()">arrow_back</mat-icon>
            </button>
          }
        </mat-toolbar>
      </div>
    }
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
